import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  claimTemplatePack: {
    method: 'POST',
    url: `${configs.baseUrl}/api/template-packs/{slug}/claim`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const claimTemplatePack = async (slug, idempotencyKey) => {
  const res = await resource.claimTemplatePack({ slug }, { idempotencyKey })

  return res && res.body
}

export default {
  initResource,
  claimTemplatePack,
}
